// @mui
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
// types
import { MembershipStatuses, ReportColumnDto } from 'src/api';
// constants
import { booleanAggregationModels } from '../constants/aggregation-model/boolean';

export function ChurnColumn(index: number) {
  const column = {
    field: 'lostMember',
    headerName: 'Lost member',
    description: 'Whether the member was lost in this period',
    type: 'boolean',
    width: 150,
    index,
    groupable: true,
    availableAggregationFunctions: [...booleanAggregationModels, 'Churn'],
    headerAlign: 'center',
    align: 'center',
    valueGetter: (value: any, row: any) => {
      if (row && row.startMembershipStatus?.status && row.endMembershipStatus?.status) {
        return calculateChurn(row.startMembershipStatus.status, row.endMembershipStatus.status);
      }
      return null;
    },
    renderCell: (params: any) => {
      if (params.value === true) {
        return <CheckIcon />;
      }
      if (params.value === false) {
        return <ClearIcon color="disabled" />;
      }

      return null;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}

const calculateChurn = (initial: MembershipStatuses, end: MembershipStatuses) => {
  if (initial === MembershipStatuses.Active && end !== MembershipStatuses.Active) {
    return true;
  }
  return false;
};
